import { BACKEND } from "../variables";
import axios from "axios";

const GET_CATEGORIES_BY_HOUSE_URL = BACKEND + "/expenseCategories/getCategoriesByHouse";
const CREATE_CATEGORY_URL = BACKEND + "/expenseCategories/create";
const UPDATE_CATEGORY_URL = BACKEND + "/expenseCategories/update";
const DELETE_CATEGORY_URL = BACKEND + "/expenseCategories/delete";

const expenseCategories = {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    ["GET_EXPENSE_CATEGORIES"]: (state, payload) => {
      return axios({
        url: GET_CATEGORIES_BY_HOUSE_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["CREATE_EXPENSE_CATEGORY"]: (state, payload) => {
      return axios({
        url: CREATE_CATEGORY_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["UPDATE_EXPENSE_CATEGORY"]: (state, payload) => {
      return axios({
        url: UPDATE_CATEGORY_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["DELETE_EXPENSE_CATEGORY"]: (state, payload) => {
      return axios({
        url: DELETE_CATEGORY_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
  },
  modules: {},
};

export default expenseCategories;

